// Общая утилита для извлечения нужных частей номера
function parsePhoneParts(number: string) {
  if (!number) return null;
  const digits = number.replace(/\D/g, '');
  return {
    country: digits.slice(0, 3),
    code: digits.slice(3, 5),
    part1: digits.slice(5, 8),
    part2: digits.slice(8, 10),
    part3: digits.slice(10)
  };
}

type TPhoneOptions = {
  space?: boolean;
};

export function formatPhoneNumber(
  number: string,
  options: TPhoneOptions = { space: true }
) {
  const parts = parsePhoneParts(number);
  const { space } = options;
  if (!parts) return number;
  const { country, code, part1, part2, part3 } = parts;

  if (space) return `+${country} (${code}) ${part1}-${part2}-${part3}`;
  return `+${country}(${code})${part1}-${part2}-${part3}`;
}

export const formatPrice = (price: number | string) => {
  if (price === '' || price === null || price === undefined) return '';
  if (typeof price === 'string') {
    price = Number(price.replace(/\D/g, ''));
  }
  return price.toLocaleString('ru-RU');
};
